@if (!isDismissed()) {
  <div class="coverage-notification-banner" [ngClass]="backgroundClass()">
    <div class="banner-content">
      <div class="banner-content-text">
        <div class="title-row">
          @if (iconName()) {
            <iris-icon                                                            
              class="warning-icon" 
              [name]="iconName()"
              [colorToken]="isEapWarning() || isEapAlert() || isAddPaymentMethod() || isCashPay() ? '$color-neutral-default' : '$color-dec-red-70'"
              [size]="iconSizes.MD">
            </iris-icon>
          }
          <h4 class="banner-title iris-h4-mobile">
            {{ config().title }}
          </h4>
        </div>

        <p class="banner-subtitle" data-test="banner-subtitle">
          {{ config().subtitle }}
          @if (config().link) {
            <a 
              class="banner-action-link iris-link-responsive"
              data-test="coverage-notification-action-link"
              (click)="config().linkClick()"
              (keydown.enter)="config().linkClick()"
              tabindex="0"
              role="button">
              {{ config().link }}
            </a>
          }
        </p>
      </div>
    
      @if (!onInsurancePage()) {
        <div class="banner-action">    
          <a 
            class="banner-action-link iris-link-responsive"
            data-test="coverage-notification-action-link"
            (click)="config().actionLinkClick()"
            (keydown.enter)="config().actionLinkClick()"
            tabindex="0"
            role="button"
          >
            {{ config().actionText }}
          </a>
          @if (showDismissButton()) {
            <button 
              class="dismiss-button-mobile"
              (click)="onDismiss()"
              aria-label="Dismiss notification"
              data-test="dismiss-banner-button"
              type="button"
            >
              <iris-icon name="close" [size]="iconSizes.SM"></iris-icon>
            </button>
          }
        </div>
      }

      @if (showDismissButton()) {
        <button 
          class="dismiss-button"
          (click)="onDismiss()"
          aria-label="Dismiss notification"
          data-test="dismiss-banner-button"
          type="button"
        >
          <iris-icon name="close" [size]="iconSizes.SM"></iris-icon>
        </button>
      }
    </div>

    @if (onInsurancePage() && (isEapWarning() || isEapAlert() || isAddPaymentMethod())) {
      <div class="banner-action-buttons">  
        <iris-button-container [alignment]="irisButtonContainerAlignments.START">
          @if (!isAddPaymentMethod()) {
            <iris-button [type]="irisButtonTypes.SECONDARY" (click)="onAddInsurance()">
              Add insurance
            </iris-button>
          }

          <iris-button [type]="irisButtonTypes.TERTIARY" (click)="onAddPaymentMethod()">
            @if (isAddPaymentMethod()) {
              Add payment method
            } @else {
              Continue with self-pay
            }
          </iris-button>
        </iris-button-container>
      </div>
    }
  </div>
}